export default "__VITE_ASSET__C$Q7UdzH__"